<template>
  <div id="union">
    <!--加入公会-->
    <div class="d1 relativeItem">
      <img src="../../assets/ghbk (2).jpg" class="imgBlock">

      <!--公会信息-->
      <div class="msg m1 absoluteItem centerX radius05rem">
        <img class="title imgBlock absoluteItem centerX" src="../../assets/gh (8).png">
        <div class="left absoluteItem centerY">
          <img src="../../assets/gh (7).png" class="imgBlock" v-if="ghdata.level == '1'">
          <img src="../../assets/gh (2).png" class="imgBlock" v-else-if="ghdata.level == '2'">
          <img src="../../assets/gh (3).png" class="imgBlock" v-else-if="ghdata.level == '3'">
          <p>{{ ghdata.leveltext }}</p>
        </div>
        <div class="right">
          <p class="p1">公会：{{ ghdata.name }}</p>
          <p class="p2">简介：互动视频娱乐交友，24小时不间断 嗨歌、热舞互动娱乐，给您带来超凡体验！ 让女神也能成为“女朋友”！</p>
        </div>
      </div>
    </div>

    <!--合同信息-->
    <div class="d2">
      <!--合同内容-->
      <div class="msg m2 relativeItem radius05rem">
        <img class="title imgBlock absoluteItem centerX" src="../../assets/gh (9).png">
        <uniontext></uniontext>
      </div>

      <div class="an">
        <p class="p1">
          <span>关于</span>
          <router-link to="/mztext">《平台免责协议》</router-link>
        </p>
        <img src="../../assets/gh (4).png" @touchstart="showTc" v-if="!old">
        <img src="../../assets/gh (5).png" @touchstart="changeAc" v-else>
        <p class="p2" v-if="old">您已经加入 {{ oldname }} 公会</p>
      </div>
    </div>

    <!--确认弹框-->
    <div class="tc" v-show="tc">
      <div class="main radius05rem whiteB centerImg">
        <p @click="agree = !agree">
          <img src="../../assets/pay (7).png" v-if="!agree">
          <img src="../../assets/gh (1).png" v-else>
          <span>我已</span>
          <span class="red">阅读并知晓</span>
          <span>入会合同内容及《平台免责协议》，同意加入此工会</span>
        </p>
        <div class="buan overHidden">
          <button class="left radius3" :class="{click:agree}" @touchstart="confirm">同意</button>
          <button class="right radius3" @touchstart="closeTc">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uniontext from "./uniontext";

export default {
  name: "union",
  components: {
    uniontext
  },
  data() {
    return {
      tc: false, //是否显示弹窗
      agree: false,
      ghdata: {
        name: "",
        leveltext: "",
        level: ""
      },
      oldname: "",
      old: false //是否已加入公会
    };
  },
  methods: {
    /**打开弹窗 */
    showTc() {
      this.tc = true;
      document.body.style.overflow = "hidden";
    },
    closeTc() {
      this.tc = false;
      document.body.style.overflow = "scroll";
    },

    /**点击同意 */
    confirm() {
      if (!this.agree) {
        return;
      }
      //进行绑定
      this.bangd();
    },

    /**切换账号 */
    changeAc(){
      this.$router.push({ path: "/login?repath=union" });
    },

    /**根据uid查看邀请公会名称 */
    seeYQ() {
      let _this = this;
      let data = {
        uid: this.$route.query.uid
      };
      this.$jsonp(this.$apis("guildNme", "app"), data, res => {
        if (res.data.data.status == 200) {
          _this.ghdata.name = res.data.data.data;
          _this.ghdata.level = res.data.data.level;
          if (_this.ghdata.level == "1") {
            _this.ghdata.leveltext = "白银公会";
          } else if (_this.ghdata.level == "2") {
            _this.ghdata.leveltext = "黄金公会";
          } else {
            _this.ghdata.leveltext = "钻石公会";
          }
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },

    /**查看用户是否加入公会 */
    joined() {
      let _this = this;
      this.$jsonp(this.$apis("whetherJoinGuild", "app"), {}, res => {
        if (res.data.data.status == 200) {
          _this.old = true;
          _this.oldname = res.data.data.data;
          _this.$tool.tip("您已加入 " + _this.oldname + " 公会")
        }
      });
    },

    /**检查用户是否登录，或者是否登录有效 */
    islogin() {
      //判断连接上是否有参数
      if (
        !this.$tool.isStr(this.$route.query.uid) &&
        !this.$tool.isStr(this.$route.query.u)
      ) {
        return;
      }

      //判断用户是否登录
      if (this.$tool.isStr(this.$cookie.getC("token"))) {
        //判断用户是否登录有效
        let _this = this;
        this.$jsonp(this.$apis("tokenVerify"), {}, res => {
          if (!res.data.data.status) {
            //跳到登录
            _this.$router.push({ path: "/login?repath=union" });
          } else {
            //查询邀请公会
            _this.seeYQ();
            //查看是否已经加入
            _this.joined();
          }
        });
      } else {
        //跳到登录
        this.$router.push({ path: "/login?repath=union" });
      }
    },

    /**绑定操作 */
    bangd() {
      this.$tool.showLoading();
      let data = {
        userid: this.$route.query.userid
      };
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.uid = this.$route.query.uid;
      } else if (this.$tool.isStr(this.$route.query.u)) {
        data.uid = this.$route.query.u;
      }

      let _this = this;
      this.$jsonp(this.$apis("blankbd", "app"), data, res => {
        _this.$tool.hiddenLoading();
        if (res.data.data.status == 200) {
          _this.$tool.tip(res.data.data.msg);
          _this.oldname = res.data.data.data;
          _this.old = true;
          //关闭弹窗
          _this.closeTc();

        } else {
          _this.$tool.tip(res.data.data.msg);
        }
      });
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("朱贝");
    this.islogin();
    document.getElementById("union").scrollTop = 0;
  }
};
</script>








<style scoped>
#union{
  height: 100vh;
  overflow: scroll;
}
.d2 {
  background: url("../../assets/ghbk (1).jpg") left top;
  background-size: 100% auto;
}
.msg {
  margin: 0 auto;
  width: 85%;
  border: 2px solid #fff;
  box-shadow: 0 0 25px rgba(208, 46, 134, 1),
    0 0 25px rgba(208, 46, 134, 1) inset;
  padding: 0.8rem;
  padding-top: 1.5rem;
  background-color: #39155b;
}
.msg .title {
  width: 35%;
  height: 46px;
  top: -1.2rem;
}
.m1 {
  bottom: 10px;
  padding-left: 4.3rem;
}
.m1 .left {
  width: 20%;
  left: 0;
  font-size: 10px;
  color: #fff;
  text-align: center;
}
.m1 .left img {
  width: 60%;
  margin: 0 auto;
}
.m1 .p1 {
  font-size: 13px;
  color: #00ffeb;
  margin-bottom: 0.4rem;
}
.m1 .p2 {
  font-size: 13px;
  color: #fff;
  text-align: justify;
}

/*合同区域*/
.d2 {
  padding-top: 2rem;
}

/*按钮部分*/
.an {
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 1.5rem;
}
.an .p1 {
  font-size: 13px;
  color: #00ffeb;
}
.an a {
  font-size: 13px;
  color: #00ffeb;
  text-decoration: underline;
}
.an img {
  width: 36%;
  margin-top: 1.3rem;
  margin-bottom: 0.3rem;
  transform-origin: center center;
  animation: shareliwu 2.5s infinite;
  -webkit-animation: shareliwu 2.5s infinite;
}
.an .p2 {
  font-size: 13px;
  color: #e23f52;
}

/*弹窗部分*/
.main {
  width: 85%;
  padding: 0.8rem;
  transform-origin: left top;
  animation: showDownload 0.2s;
  -webkit-animation: showDownload 0.2s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.main p * {
  font-style: normal;
  font-size: 13px;
}
.main p img,
.main p span {
  vertical-align: middle;
}
.main p .red {
  color: #ff4757;
}
.main p img {
  width: 0.9rem;
  margin-right: 0.5rem;
}
.buan {
  margin-top: 1.7rem;
}
.buan button {
  text-align: center;
  font-size: 15px;
  border: 1px solid #ccc;
  width: 45%;
  padding: 0.55rem 0;
}
.buan .left {
  float: left;
  color: white;
  background: #ccc;
}
.buan .click {
  color: white;
  background: #fd79a8;
  border: 1px solid #fd79a8;
}
.buan .right {
  float: right;
  color: #ccc;
  background: #fff;
}
</style>
